export const sum = (data: { value: number }[]) => data.reduce((sum, curr) => curr.value + sum, 0);

export const calcPercentage = (value: number, total: number) => {
  if (!total) return 0;
  return Number((value / total).toFixed(0));
};
